import VideoImg from "../../images/choose-us/main-img.png";
import TrainingIcon from "../../images/choose-us/training.png";
import EquipmentsIcon from "../../images/choose-us/bench-press.png";
import BagIcon from "../../images/choose-us/gym-bag.png";
import BottleIcon from "../../images/choose-us/bottle-of-water.png";
import PlayImg from "../../images/choose-us/play.png";
import MainButton from "../MainButton";

function ChooseUs() {
  return (
    <>
      <section className="choose-section py-[60px] md:py-[80px] lg:py-[120px]">
        <div className="container page-padding flex flex-col lg:flex-row lg:gap-[70px] gap-[40px] md:gap-[60px] items-center">
          
          {/* Video Section */}
          <div className="video-div relative w-full lg:w-[50%] max-w-[600px] lg:max-w-none">
            <img 
              src={VideoImg} 
              alt="fat2fit_gym" 
              className="relative w-full h-auto animate-pulse rounded-2xl" 
            />
            {/* Play Button - Better positioned for all screen sizes */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative cursor-pointer group">
                <span className="block bg-white p-6 sm:p-10 md:p-14 rounded-full opacity-75 group-hover:opacity-100 transition-opacity duration-300"></span>
                <img
                  src={PlayImg}
                  alt="play_icon"
                  className="absolute w-[20px] sm:w-[24px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10"
                />
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="relative w-full lg:w-[50%] text-center lg:text-left">
            
            {/* Title with Background */}
            <div className="relative inline-flex items-center justify-center gap-2 bg-[#ff0336] text-white text-[12px] sm:text-[13px] uppercase font-bold tracking-[3px] px-6 py-2 rounded-lg transform -skew-x-12 shadow-lg shadow-[#ff0336]/20 mb-6 sm:mb-8 mx-auto lg:mx-0">
              <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse"></span>
              <span>why choose us</span>
            </div>

            <h2 className="text-[28px] sm:text-[32px] md:text-[36px] text-white font-bold leading-[1.2] max-w-full lg:max-w-3xl mx-auto lg:mx-0">
              We Can Shape Your Body &amp; Mind Here!
            </h2>

            <p className="text-[15px] sm:text-[16px] md:text-[16.5px] text-[#b4b4b4] mt-4 sm:mt-5 md:mt-7 max-w-full lg:max-w-3xl mx-auto lg:mx-0">
              At <b>FAT2FIT Unisex Fitness Centre</b>, we are dedicated to helping you achieve the
              body of your dreams. Our expert trainers and custom lifestyle coaching will guide
              you to reach your fitness goals in a safe, friendly environment.
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 md:gap-10 lg:gap-14 max-w-full lg:max-w-[440px] mt-6 sm:mt-8 md:mt-10 lg:mt-14 mx-auto lg:mx-0">
              
              {/* Feature 1 */}
              <div className="flex items-center gap-4 sm:gap-6 justify-center lg:justify-start">
                <img
                  className="bg-[#2b2b2b] hover:bg-brand-gradient ease-in duration-200 w-[55px] sm:w-[60px] md:w-[65px] rounded-full p-3 sm:p-4 flex-shrink-0"
                  src={TrainingIcon}
                  alt="icon"
                />
                <p className="text-white font-bold text-[15px] sm:text-[16px] md:text-[18px] max-w-[130px] sm:max-w-[150px] text-left">
                  Free Fitness Training
                </p>
              </div>

              {/* Feature 2 */}
              <div className="flex items-center gap-4 sm:gap-6 justify-center lg:justify-start">
                <img
                  className="bg-[#2b2b2b] hover:bg-brand-gradient ease-in duration-200 w-[55px] sm:w-[60px] md:w-[65px] rounded-full p-3 sm:p-4 flex-shrink-0"
                  src={EquipmentsIcon}
                  alt="icon"
                />
                <p className="text-white font-bold text-[15px] sm:text-[16px] md:text-[18px] max-w-[130px] sm:max-w-[150px] text-left">
                  Modern Gym Equipments
                </p>
              </div>

              {/* Feature 3 */}
              <div className="flex items-center gap-4 sm:gap-6 justify-center lg:justify-start">
                <img
                  className="bg-[#2b2b2b] hover:bg-brand-gradient ease-in duration-200 w-[55px] sm:w-[60px] md:w-[65px] rounded-full p-3 sm:p-4 flex-shrink-0"
                  src={BagIcon}
                  alt="icon"
                />
                <p className="text-white font-bold text-[15px] sm:text-[16px] md:text-[18px] max-w-[130px] sm:max-w-[150px] text-left">
                  Gym Bag Equipments
                </p>
              </div>

              {/* Feature 4 */}
              <div className="flex items-center gap-4 sm:gap-6 justify-center lg:justify-start">
                <img
                  className="bg-[#2b2b2b] hover:bg-brand-gradient ease-in duration-200 w-[55px] sm:w-[60px] md:w-[65px] rounded-full p-3 sm:p-4 flex-shrink-0"
                  src={BottleIcon}
                  alt="icon"
                />
                <p className="text-white font-bold text-[15px] sm:text-[16px] md:text-[18px] max-w-[130px] sm:max-w-[150px] text-left">
                  Fresh Bottle Water
                </p>
              </div>

              {/* Button - Centered on mobile, aligned left on desktop */}
              <div className="sm:col-span-2 flex justify-center lg:justify-start mt-2 sm:mt-4">
                <MainButton
                  color={`!text-white`}
                  bg={`bg-brand-gradient`}
                  text="our trainings"
                  arrowColor={`!text-white`}
                  cN="choose-cta hover-brand-gradient w-full sm:w-auto"
                  goTo="/trainings"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ChooseUs;